import { Input, Output, EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Plan } from '../../../models/plan.model';
import { CookieCiencuadras } from '../../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { addToCarPlan} from '../../../redux/actions/carPlanCheckout.actions';
@Component({
  selector: 'app-base-card',
  templateUrl: './base-card.component.html',
  styleUrls: ['./base-card.component.scss']
})
export class BaseCardComponent implements OnInit {

  @Input()
  dataPlan!: Plan;
  @Input()
  selectedOne: boolean = false;
  @Output() setSelectedPlan = new EventEmitter<number>();
  image_url: string = './assets/images/products/';
  idPlan: number = 0;



  constructor(public cookieCiencuadras: CookieCiencuadras,
              private store: Store<AppState>) { 
        this.idPlan = parseInt(sessionStorage.getItem("idPlanSelect"));
      }


  ngOnInit(): void {
  }

  selectPlan(plan) {
    this.idPlan = plan.id;
    sessionStorage.setItem("idPlanSelect", plan.id);
    this.setSelectedPlan.emit(plan);
  }

}
